import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { DivisionChange } from '@sorare/core/src/__generated__/globalTypes';
import { BrandS } from '@sorare/core/src/atoms/typography';
import { absCenter } from '@sorare/core/src/lib/style';
import { Color } from '@sorare/core/src/style/types';

import { messages } from 'components/managerTeam/Status/messages';

import promoted from './assets/promoted.svg';
import relegated from './assets/relegated.svg';
import safe from './assets/safe.svg';

const Root = styled.div`
  position: relative;
`;
const AbsoluteBrandS = styled(BrandS)`
  z-index: 1;
  ${absCenter}
`;
const Img = styled.img`
  width: 100%;
`;

const divisionChangeAttr: Record<
  DivisionChange,
  { img: string; color: Color }
> = {
  [DivisionChange.PROMOTED]: { img: promoted, color: 'var(--c-green-400)' },
  [DivisionChange.RELEGATED]: { img: relegated, color: 'var(--c-red-400)' },
  [DivisionChange.STABLE]: { img: safe, color: 'var(--c-nd-600)' },
};
type Props = { divisionChange: DivisionChange };
export const DivisionChangeBanner = ({ divisionChange }: Props) => {
  const message = messages[divisionChange];
  const { img, color = 'var(--c-nd-600)' } = divisionChangeAttr[divisionChange];

  return (
    <Root>
      <AbsoluteBrandS color={color}>
        <FormattedMessage {...message} />
      </AbsoluteBrandS>
      <Img src={img} alt="" height="24" />
    </Root>
  );
};
